import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, FileTextIcon, WalletIcon, ZapIcon } from 'lucide-react';
import { heroImage, pricing } from '../data/content';
import { formatArs } from '../utils/format';
const facts = [{
  icon: FileTextIcon,
  label: '6 tomos en PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en minutos'
}, {
  icon: WalletIcon,
  label: '+6 bonus prácticos'
}];
export function Hero() {
  return <section id="top" className="w-full bg-forest-deep" data-id="element-114" data-mp="12860lxyjoar2">
      <div className="mx-auto grid max-w-content items-center gap-12 px-5 pb-16 pt-14 lg:grid-cols-[1.15fr_1fr] lg:gap-16 lg:px-8 lg:pb-24 lg:pt-20" data-id="element-115" data-mp="xannrwhepbds">
        <div data-id="element-116" data-mp="s9q6dm480ldc">
          <p className="font-display text-sm font-bold text-gold" data-id="element-117" data-mp="s9gji7eh2ubv">
            Full Tienda · Educación financiera
          </p>

          <h1 className="mt-4 font-display text-4xl font-black leading-[1.02] text-cream sm:text-5xl lg:text-6xl" data-id="element-118" data-mp="3d1ihv20l0yjq">
            Ordená tu dinero antes
            <br className="hidden sm:block" data-id="element-119" data-mp="380vy3velgpc3" /> de gastarlo.
          </h1>

          <p className="mt-5 max-w-xl text-lg leading-relaxed text-cream/80" data-id="element-120" data-mp="3j897lcz58bpj">
            <span className="font-semibold text-cream" data-id="element-121" data-mp="3o7c05xxxspgm">
              Sistema de Ahorro: El Método de los 4 Bolsillos.
            </span>{' '}
            Un programa completo, paso a paso, para controlar tus gastos, salir
            de las cuotas y construir ahorros reales con los ingresos que ya
            tenés.
          </p>

          <ul className="mt-7 flex flex-wrap gap-x-6 gap-y-3" data-id="element-122" data-mp="30h9blrt8e1mr">
            {facts.map(fact => <li key={fact.label} className="flex items-center gap-2 text-sm font-medium text-cream/75" data-id="element-123" data-mp="358zp26ngt5ie">
                <fact.icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-124" data-mp="2qkwk90l5rzv6" />
                {fact.label}
              </li>)}
          </ul>

          <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-125" data-mp="2vgu0l6wf967y">
            <a href="#comprar" className="inline-flex items-center justify-center rounded-lg bg-gold px-7 py-4 font-display text-base font-extrabold uppercase tracking-wide text-forest-deep transition-colors duration-150 ease-out hover:bg-gold-deep" data-id="element-126" data-mp="2hjox9eo3elge">
              Empezar hoy — {formatArs(pricing.price)}
            </a>
            <p className="text-sm text-cream/60" data-id="element-127" data-mp="n98g9vpnzjrl">
              Pago único ·{' '}
              <span className="line-through" data-id="element-128" data-mp="ichz1524ii4l">{formatArs(pricing.anchor)}</span>{' '}
              precio habitual
            </p>
          </div>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 border-t border-white/10 pt-6 text-xs text-cream/60" data-id="element-129" data-mp="1b0nmw0oh4n8n">
            <span className="flex items-center gap-1.5" data-id="element-130" data-mp="161jbr4hzoffo">
              <CheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-131" data-mp="15zzwnh82kafh" />
              Garantía de 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-132" data-mp="x1nxurx1u6by">
              <CheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-133" data-mp="x37bearbm3a1" />
              Mercado Pago, tarjeta o transferencia
            </span>
            <span className="flex items-center gap-1.5" data-id="element-134" data-mp="3hr3q7rbx233p">
              <CheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-135" data-mp="3htpyxuajmoni" />
              Sin conocimientos previos
            </span>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative" data-id="element-136" data-mp="21bft1j0ev3ra">
          <div className="rounded-2xl bg-cream p-6 shadow-card lg:p-8" data-id="element-137" data-mp="2fzssipypj4qj">
            <img src={heroImage} alt="Los 6 tomos del Sistema de Ahorro: El Método de los 4 Bolsillos" className="mx-auto w-full max-w-md" data-id="element-138" data-mp="2fziymrajkdfk" />
          </div>
          <p className="mt-4 text-center text-xs font-medium uppercase tracking-wide text-cream/50" data-id="element-139" data-mp="2p08vlybjg9uv">
            Material 100% digital · Descargable e imprimible
          </p>
        </motion.div>
      </div>
    </section>;
}